export function isJSSlot(data) {
  return data && data.type === 'JSSlot';
}